
import { useState, useEffect, useMemo } from 'react';

const PERFECT_QUIPS = [
  "Perfect logic! Your wavelength just synced with the cosmos.",
  "Perfect logic! Great minds think precisely like yours.",
  "Perfect logic! Your neural pathways are on the group chat.",
  "Perfect logic! Your thoughts echo through the collective unconscious.",
  "Perfect logic! You've tapped into the universal frequency.",
  "Perfect logic! Your brain's tuned to the right channel today.",
  "Perfect logic! You caught the thought-wave everyone's riding.",
  "Perfect logic! Your mental compass points true north—like everyone's should.",
  "Perfect logic! You've decoded the shared blueprint.",
  "Perfect logic! Your mind's broadcasting on the genius frequency.",
  "Perfect logic! Your neurons are networking with excellence.",
  "Perfect logic! You just found the hidden consensus.",
  "Perfect logic! Your thoughts are trending before they're even spoken.",
  "Perfect logic! Your insight resonates across the collective mind.",
  "Perfect logic! You've discovered the invisible thread that connects everything.",
  "Perfect logic! Your mental GPS has found the perfect coordinates.",
  "Perfect logic! Your thoughts arrived at the universal meeting point.",
  "Perfect logic! You've unlocked the shared wisdom circuit.",
  "Perfect logic! Your brainwaves just harmonized with the universe.",
  "Perfect logic! You've found the invisible thread in the thought tapestry.",
  "Perfect logic! Your mental radar detected what everyone was sensing.",
  "Perfect logic! Your intuition speaks the universal language.",
  "Perfect logic! You've tuned your mind to the frequency of brilliance.",
  "Perfect logic! Your thoughts just high-fived the collective unconscious.",
  "Perfect logic! Your mental compass found magnetic north on the first try.",
  "Perfect logic! You've decoded the signal everyone else is receiving.",
  "Perfect logic! Your brain just joined the telepathic group chat.",
  "Perfect logic! You've accessed the shared mental library.",
  "Perfect logic! Your neurons are dancing to the same rhythm as the stars.",
  "Perfect logic! Your mind found the shortcut everyone was looking for.",
  "Perfect logic! You've glimpsed the blueprint behind everyone's thinking.",
  "Perfect logic! Your thoughts just synchronized with the cosmic clock.",
  "Perfect logic! Your mental puzzle piece completes the bigger picture."
];

const HISTORY_KEY = 'perfect_quip_history';
const HISTORY_LIMIT = 14; // Don't repeat a quip within 14 perfect results

/**
 * Hook that provides celebratory quips for perfect match results
 * Ensures quips don't repeat within the last 14 perfect scores
 */
export function useResultQuips() {
  // Get a random quip for perfect logic matches that hasn't been used recently
  const quip = useMemo(() => {
    // Get history of recently used quips
    const historyJson = localStorage.getItem(HISTORY_KEY);
    const recentQuips: string[] = historyJson ? JSON.parse(historyJson) : [];
    
    // Filter out recently used quips
    const availableQuips = PERFECT_QUIPS.filter(q => !recentQuips.includes(q));
    
    // If we've used all quips or nearly all, reset by using the least recently used ones
    const quipsToUse = availableQuips.length > 3 ? availableQuips : PERFECT_QUIPS;
    
    // Select a random quip from available options
    const randomIndex = Math.floor(Math.random() * quipsToUse.length);
    const selectedQuip = quipsToUse[randomIndex];
    
    // Update history
    const newHistory = [selectedQuip, ...recentQuips.filter(q => q !== selectedQuip)]
      .slice(0, HISTORY_LIMIT);
    localStorage.setItem(HISTORY_KEY, JSON.stringify(newHistory));
    
    return selectedQuip;
  }, []);

  return { quip };
}
